import React from 'react';


class WaitCube extends React.Component {

  render () {
		return (
		  <div className="sk-folding-cube" style={this.props.style!==undefined?this.props.style:{}}>
        <div className="sk-cube1 sk-cube"></div>
        <div className="sk-cube2 sk-cube"></div>
        <div className="sk-cube4 sk-cube"></div>
        <div className="sk-cube3 sk-cube"></div>
      </div>
    )
  }
}
export default WaitCube;
